module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "A5m"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz13-3"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")])]), _vm._v("fter His temptations with Satan ended, Jesus began His earthly ministry. While Jesus walked by the Sea of Galilee, He came upon two brothers, Simon Peter and Andrew. He did not beg them to follow Him or make great promises about what the future with Him held. Jesus simply said, “Follow Me, and I will make you fishers of men.” The two brothers immediately dropped what they were doing and began to follow Jesus. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz13-4"
    }
  }, [_vm._v("Today Jesus calls you to follow Him, to drop your old way of life and live as He models and teaches you to live. When you choose to follow Him, the relationship you forge with Jesus will give your life meaning and purpose. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz13-5"
    }
  }, [_vm._v("God gives everyone certain talents and gifts that He wants him or her to use for His glory. He also uses Christians when they willingly surrender their lives to Him. When you do this day in and day out, you will experience a richness and joy as you live with His Spirit alive in your heart. What greater blessing could you ever ask for? The Lord calls you today. Will you follow Him? ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba09d7e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter08.vue
// module id = 87
// module chunks = 0